import { ClientSelector } from 'components/shared/client-selector';
import { ColoredToggleButton } from 'components/shared/ColoredToggleButton';
import { VerticalDivider } from 'components/shared/Divider';
import { useIsInternalUser } from 'hooks/useIsInternalUser';
import { ISalesCounterpart } from 'models/ISalesCounterpart';
import { useRef } from 'react';
import { useFormFieldData } from 'routes/essential-workspace/components/form/use-form-field-data';

const TabFormFields = () => {
  const isInternal = useIsInternalUser();
  const [client, setClient] = useFormFieldData<Nullable<ISalesCounterpart>>('SelectedOnBehalfClient');
  const [isPrivateMode, setIsPrivateMode] = useFormFieldData<Nullable<boolean>>('IsPrivateMode');
  const clientSelectorRef = useRef<HTMLDivElement | null>(null);

  if (!isInternal) {
    return null;
  }

  return (
    <div className="flex-x gap-2 position-relative tab-form-fields" ref={clientSelectorRef}>
      <ClientSelector
        id="clientSelector"
        containerRef={clientSelectorRef}
        onClientChanged={setClient}
        client={client}
      />
      <ColoredToggleButton
        id="isPrivateMode"
        iconName={isPrivateMode ? 'visibility_off' : 'visibility'}
        labelKey={isPrivateMode ? 'form.IsPrivateMode' : 'form.IsPrivateMode.false'}
        value={isPrivateMode ?? false}
        isDisabled={false}
        onValueChanged={setIsPrivateMode}
        className="border-0 flex-shrink-0 private-mode-btn"
        iconPosition="right"
      />
      <VerticalDivider className="vertical-divider" />
    </div>
  );
};

export default TabFormFields;
